import React from "react";

export default function StatisticCard({title, balance, incoming, outgoing}){
    return(
        <div className="mb-4">
            <div className="card">
                <div className="card-body">
                    {title && (
                        <span className="fw-semibold d-block mb-1">{title}</span>
                    )}
                    {balance && (
                        <h3 className="card-title mb-2">{balance}</h3>
                    )}
                    {incoming && (
                        <small className="text-success fw-semibold"><i
                            className="bx bx-up-arrow-alt"></i>{incoming}</small>
                    )}
                    {outgoing && (
                        <small className="text-danger fw-semibold"><i
                            className="bx bx-down-arrow-alt"></i>{outgoing}</small>
                    )}
                </div>
            </div>
        </div>
    );
}